




















import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import TheSidebar from "@/components/TheSidebar.vue";
import TheTopbar from "@/components/TheTopbar.vue";

@Component({ components: { TheSidebar, TheTopbar } })
export default class App extends Vue {
  @Getter("locked") readonly locked!: boolean;
  @Getter("mode") readonly mode!: string;

  get appClass() {
    return {
      "app--locked": this.locked,
    };
  }

  get overlayIsVisible(): boolean {
    return this.locked || this.mode == "loading";
  }
}
